<div>
    <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#staticBackdrop">
        上傳圖片
    </button>
      
      <!-- Modal -->
      <div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="staticBackdropLabel">請選擇圖片上傳</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <div class="row" style="margin-top: 5%;">
                    <div class="text-center col-md-6">
                        <h5 *ngIf="croppedImage">原圖</h5>
                        <image-cropper 
                        [imageChangedEvent]="imageChangedEvent" 
                        [maintainAspectRatio]="true" 
                        [aspectRatio]="4 / 4"
                        [resizeToWidth]="300" 
                        format="png" 
                        (imageCropped)="imageCropped($event)" 
                        (imageLoaded)="imageLoaded()"
                        (cropperReady)="cropperReady()" 
                        (loadImageFailed)="loadImageFailed()"></image-cropper>
                    </div>
                    <div class="col-md-1">
                    </div>
                    <div class="text-center col-md-3">
                        <h5 *ngIf="croppedImage">裁切後</h5>
                        <img [src]="croppedImage" />
                    </div>
                </div> 
            </div>
            <div class="modal-footer">
                <div class="btn btn-info" style="position:relative;margin-left:10px;">
                    <input style="opacity:0;width:100%;height:100%;position:absolute;left:0;top:0;" type="file" (change)="fileChangeEvent($event)"
                    placeholder="Upload file" accept=".jpeg,.jpg,.png,.gif">點我上傳
                </div>
                <button type="button" class="btn btn-primary" (click)="confirm()" data-dismiss="modal">確定裁切</button>
            </div>
          </div>
        </div>
      </div>
  
  
   
 

  
</div>